<template>
  <div class="wrapper">
    <base-bread-crumb :currBreadCrumb="currBreadCrumb"></base-bread-crumb>
    <div class="ccui-app-container">
      <!--评标结果-->
      <div v-if="type == 3" style="font-size:17px">
        {{ $t("page.content.labelMenu1") }}
      </div>
      <!--高级搜索Begin-->
      <div class="ccui-advanced-search-wrapper ccui-clearfix">
        <el-search
          ref="elSearch"
          width="460px"
          :formProp="formData"
          @search="search"
          :isShowSearch="true"
          :isShow="true"
          class="ccui-highsearch no-print"
        >
          <template slot="search">
            <el-date-picker
              v-model="formData.noticeTime"
              :searchLabel="$t('page.content.publishTime')"
              clearable
              type="daterange"
              value-format="yyyy-MM-dd"
              :range-separator="$t('page.content.to')"
              :start-placeholder="$t('page.content.startTime')"
              :end-placeholder="$t('page.content.endTime')"
            >
            </el-date-picker>
            <el-input
              v-model.trim="formData.noticeTitle"
              clearable
              :searchLabel="$t('page.content.title')"
              :placeholder="$t('page.content.titlePlaceholder')"
            ></el-input>
          </template>
          <el-input
            v-model.trim="formData.noticeTitle"
            clearable
            :searchLabel="$t('page.content.title')"
            :placeholder="$t('page.content.titlePlaceholder')"
            slot="searchItem2"
          ></el-input>
          <!--状态 请选择状态查询 -->
          <el-select
            v-model="formData.noticeStatus"
            clearable
            :searchLabel="$t('page.content.status')"
            :placeholder="$t('page.content.pleaseSelectStatus')"
            slot="searchItem3"
          >
            <el-option
              v-for="item in statusOptions"
              :key="item.dicKey"
              :label="item.dicValue"
              :value="item.dicKey"
            ></el-option>
          </el-select>
          <el-date-picker
            v-model="formData.noticeTime"
            :searchLabel="$t('page.content.publishTime')"
            clearable
            type="daterange"
            value-format="yyyy-MM-dd"
            :range-separator="$t('page.content.to')"
            :start-placeholder="$t('page.content.startTime')"
            :end-placeholder="$t('page.content.endTime')"
            slot="searchItem1"
          >
          </el-date-picker>
        </el-search>
      </div>
      <!--高级搜索End-->
      <!--table表格区域Begin-->
      <div class="ccui-multifunctional-table-wrapper">
        <listBaseTable
          :tableName="tableName"
          :showCheckBox="false"
          :showOp="false"
          :data="tableData"
          :cellStyle="cellStyle"
          :pageNo.sync="pageNo"
          :pageSize.sync="pageSize"
          :pageTotal="pageTotal"
          :fixedTableThead="fixedTableThead"
          :unfixedTableThead="unfixedTableThead"
          border
          @handleList="handleList"
          @select-all="handleCheckAllChange"
          @select="handleCheckChange"
          @selection-change="handleSelectionChange"
        >
          <template slot="noticeStatusName" slot-scope="{ row }">
            <span>{{
              row.noticeStatus == "3"
                ? $t("page.content.alreadyEnded")
                : $t("page.content.inThePublicity")
            }}</span>
          </template>
          <!--列表中的插槽Begin-->
          <template slot="title" slot-scope="{ row }">
            <el-button
              class="column-btn-ellipsis"
              size="mini"
              type="text"
              @click="check(row)"
            >
              {{ row.noticeTitle }}
            </el-button>
          </template>
          <!--列表中的插槽End-->
        </listBaseTable>
      </div>
      <!--table表格区域End-->
    </div>
  </div>
</template>

<script>
import { mixinListCommon } from "@/mixins/mixin-common/mixin-list";
import { commonTableWidth } from "@/setting/setting";
import baseBreadCrumb from "@/app/shop/components/baseBreadCrumb.vue";
import { listSupBidNotice } from "@/app/shop/api/shopping";
import Cookies from "js-cookie";
import moment from "moment";
export default {
  name: "noticeViewAllList",
  mixins: [mixinListCommon],
  components: {
    baseBreadCrumb
  },
  activated() {
    this.getNoticeList();
  },
  deactivated() {
    this.initData();
  },
  props: {
    currBreadCrumb: {
      type: Array,
      default: () => {
        return [];
      }
    },
    type: {
      type: String,
      default: "" //公告类型
    }
  },
  data() {
    return {
      tableName: this.tableList.viewMoreList, // 默认的tableName 工程中唯一
      isSelection: false,
      formData: {},
      statusOptions: [
        {
          //公示中
          dicKey: "2",
          dicValue: this.$t("page.content.inThePublicity")
        },
        {
          //已结束
          dicKey: "3",
          dicValue: this.$t("page.content.alreadyEnded")
        }
      ],
      formDataSearch: {},
      tableData: [],
      unfixedTableTheadAll: [],
      fixedTableThead: [],
      unfixedTableThead: Object.freeze([
        {
          label: this.$t("page.content.serialNo"),
          prop: "id",
          type: "index",
          width: this.$TW.serialNoWidth,
          checked: true
        },
        {
          label: this.$t("page.content.title"),
          prop: "noticeTitle",
          width: 350,
          checked: true,
          slot: "title"
        },
        {
          //状态
          label: this.$t("page.content.status"),
          prop: "noticeStatusName",
          // width: 500,
          checked: true,
          slot: "noticeStatusName"
        },
        {
          label: this.$t("page.content.publishTime"),
          prop: "noticeStartTime",
          width: commonTableWidth.dateTimeWidth,
          checked: true
        }
      ]),
      pageNo: 1,
      pageSize: 10,
      pageTotal: 0,
      supInfo: this.$store.state.user.supInfo || {}
    };
  },
  methods: {
    initData() {
      this.pageNo = 1;
      this.pageSize = 10;
      this.pageTotal = 0;
      this.formData = {};
      this.formDataSearch = {};
      this.tableName = this.tableList.viewMoreList;
    },
    handleList() {
      // 分页操作列表
      this.getNoticeList();
    },
    getNoticeList() {
      let supCodeList = [];
      if (this.supInfo.getSupInfoByLoginInfoRspBOList) {
        supCodeList = this.supInfo.getSupInfoByLoginInfoRspBOList.map(item => {
          return item.supCode;
        });
      }
      let param = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        noticeType: Number(this.type),
        noticeStatusEndFlag: "1", //是否查询已结束的公告 0-否 1-是
        isShowPageLoading: true,
        supCodeList: supCodeList
      };
      if (
        Cookies.get("language") !== undefined &&
        Cookies.get("language") !== "zh-cn"
      ) {
        param.overseasSupFlag = 1;
      }
      if (
        this.formDataSearch.noticeTime &&
        this.formDataSearch.noticeTime.length !== 0
      ) {
        this.formDataSearch.noticeTimeStart =
          this.formDataSearch.noticeTime[0] + " 00:00:00";
        this.formDataSearch.noticeTimeEnd =
          this.formDataSearch.noticeTime[1] + " 23:59:59";
      }
      Object.assign(param, this.formDataSearch);
      this.$delete(param, "noticeTime");
      listSupBidNotice(param).then(res => {
        if (res.data.code === "0") {
          this.tableData = res.data.data.rows.map(item => {
            item.noticeStartTime = item.noticeStartTime
              ? moment(item.noticeStartTime).format("YYYY-MM-DD HH:mm")
              : "";
            return item;
          });
          this.pageTotal = res.data.data.recordsTotal;
        }
      });
    },
    search(searchData) {
      this.pageNo = 1;
      this.formDataSearch = searchData;
      this.getNoticeList();
    },
    //查看
    check(row) {
      let url = this.$router.resolve({
        path: "/viewNoticeSimpleDetail",
        query: {
          type: this.type,
          schemeId: row.schemeId,
          schemeName: row.schemeName,
          schemeCode: row.schemeCode,
          noticeId: row.noticeId,
          opUnitName: row.opUnitName,
          opUnitId: row.opUnitId,
          purchaseType: row.purchaseType
        }
      });
      window.open(url.href, "_blank");
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      // 判断高亮行
      return { color: "#0089EF", cursor: "pointer" };
    },
    handleCheckAllChange(arr) {
      this.isSelection = arr.length !== 0;
    },
    handleCheckChange(arr) {
      this.isSelection = arr.length !== 0;
    },
    handleSelectionChange(arr) {
      this.isSelection = arr.length !== 0;
    }
  }
};
</script>

<style scoped lang="scss">
/deep/.el-searchs {
  display: none;
  .icon-ccui-downdown {
    display: none;
  }
}
/deep/.ccui-search-wrapper {
  display: none;
}
/deep/.ccui-advanced-search-wrapper {
  .el-search .el-searchs-bottom .el-form-item .el-form-item__label {
    min-width: 0 !important;
    width: auto !important;
  }
}
/deep/.el-form-item__content {
  margin-right: 20px;
}
/deep/.el-col-8 {
  width: 28%;
}
/deep/.el-col-24 {
  width: 170px;
}
/deep/.icon-ccui-downdown {
  display: none;
}
</style>
